import type { PrimaryFilterId } from '../../../filters/types/filters';
import { ChartFallback } from '../../Chart/ChartFallback';
import { useChart } from '../../Chart/ChartProvider';
import type { CompositionMetricValues } from '../../PageConfigProvider/types/metric';
import { usePageState } from '../../PageState/PageStateProvider';
import { CompetitorDataProvider } from '../CompetitorDataProvider';
import type { DataProviderChildren, DataProviderSet } from '../types';
import { convertCompositionData } from '../utils/convert-composition-data';
import { CompositionRawDataProvider } from './CompositionRawDataProvider';

type CompositionTopCompetitorsDataProviderProps = {
  primaryDimension: PrimaryFilterId;
  metric: CompositionMetricValues;
  exchangeRate?: number;
  children: DataProviderChildren<DataProviderSet | undefined>;
};

export const CompositionTopCompetitorsDataProvider = ({
  primaryDimension,
  metric,
  exchangeRate,
  children,
}: CompositionTopCompetitorsDataProviderProps) => {
  const { pageState } = usePageState();
  const { item } = useChart();
  const selectedEntity = pageState.primaryEntities?.[item?.id];

  return (
    <CompetitorDataProvider entityId={Number(selectedEntity?.id)}>
      {({ data: entities, status }) => (
        <ChartFallback status={status}>
          <CompositionRawDataProvider
            primaryDimension={primaryDimension}
            entitiesOverride={entities}
          >
            {({ data, status }) =>
              children({
                data: data?.composition_v2
                  ? convertCompositionData({
                      metric,
                      data: data.composition_v2,
                      segment: 'competitors',
                      exchangeRate,
                    })
                  : undefined,
                status,
              })
            }
          </CompositionRawDataProvider>
        </ChartFallback>
      )}
    </CompetitorDataProvider>
  );
};
